
import { ViewController } from 'ionic-angular/navigation/view-controller';
import { BllOrtak } from './../../../providers/bll/bll-ortak';
import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Ortak } from '../../../providers/ortak';



@Component({
  selector: 'page-kredi-karti-islemleri',
  templateUrl: 'kredi-karti-islemleri.html',
})
export class KrediKartiIslemleriPage {
  KasaHareket: any = { ID: -1, KasaID: "", BelgeNo: "", IslemTuru: 6, Sign: 1, CardRef: "", Tutar: "", SlsMan: "", Text: "", AciklamaRef: 1 };
  BankaHareket: any = { ID: -1, BankRef: "", IslemTuru: 1, CardRef: "", BelgeNo: "", KasaRef: "", SlsMan: "", Text: "", Sign: 1, Tutar: "" };
  BankaListesi = [];
  KasaListesi = [];
  odemeIslemiMi: number = 0;

  aranan = "";
  skip: number = 0;
  take: number = 50;
  BankaView: any = {};

  Banka: any = { ID: -1, BankaAdi: "" };
  aktifKullanici: any;

  constructor(public navCtrl: NavController,
    public bllOrtak: BllOrtak,
    public ortak: Ortak,
    public viewctrl: ViewController,
    public navParams: NavParams) {

    if (navParams.get("BankaVw") != null) {
      this.BankaView = navParams.get("BankaVw");
      var data = new FormData();
      data.append("Banka_id", this.BankaView.ID);
      this.bllOrtak.islem(data, "BankaGetirByID", "", false).then(a => {
        var Sonuc = <any>a;
        this.Banka = Sonuc.SonucObject;
        this.BankaHareket.BankRef = this.Banka.ID;
      })
    }
    this.aktifKullanici = this.ortak.aktifKullaniciAdi;

  }




  boslukKontrol() {
    var mesaj = "";
    if (this.BankaHareket.Tutar == null || this.BankaHareket.Tutar == "") {
      mesaj = mesaj + "Lütfen geçerli bir tutar  giriniz. <br/>";
    }
    if (this.BankaHareket.OdemeTarihi == null || this.BankaHareket.OdemeTarihi == "") {
      mesaj = mesaj + "Lütfen geçerli bir tarih  giriniz. <br/>";
    }
    if (mesaj == "") {
      return true;
    }
    else {
      this.ortak.showBasicAlert("Uyarı", mesaj);
      return false;
    }

  }
  kasaGetir() {
    var formData = new FormData();
    formData.append("aranan", this.aranan);
    formData.append("skip", this.skip.toString());
    formData.append("take", this.take.toString());
    this.bllOrtak.islem(formData, "KasaListesi", "", false).then(a => {

      var sonuc = <any>a;
      this.KasaListesi = sonuc.SonucObject;


    })
  }
  kaydet() {
    if (this.boslukKontrol()) {

      var formData = new FormData();
      if (this.odemeIslemiMi == 1) {
        this.BankaHareket.Sign = 0;
        this.BankaHareket.IslemTuru = 2;
      }
      else {
        this.BankaHareket.Sign = 1;
        this.BankaHareket.IslemTuru = 1;
      }
      this.BankaHareket.BankRef = this.BankaView.ID;
      this.BankaHareket.KasaRef = this.KasaHareket.KasaID;
      this.BankaHareket.IslemiYapanPersonel = this.ortak.aktifKullaniciAdi;
      this.KasaHareket.SlsMan = this.ortak.aktifKullaniciAdi;
      formData.append("BankaHareket_json", JSON.stringify(this.BankaHareket));
      formData.append("Kasa_json", JSON.stringify(this.KasaHareket));
      this.bllOrtak.islem(formData, "BankaHareket", "", false).then(a => {
        var sonuc = <any>a;
        if (sonuc.Sonuc == 1) {
          this.ortak.showBasicAlert("Başarılı", "İşlem Başarılı");
          this.viewctrl.dismiss();
        }
        if (sonuc.Sonuc != 1) this.ortak.showBasicAlert("Hata", "Beklenmedik bir  hata oluştu.");
      })
    }
   

  }
  kapat() {
    this.viewctrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/pages/BankaIslemleri/kredi-karti-islemleri/kredi-karti-islemleri.ts